/**
 * De indeling van de vaktermenlijst.
 *
 * De lijst wordt platgeslagen tot losse woorden voordat hij naar het
 * transcriptiemodel gaat — dat heeft aan een categorie niets. Maar voor wie hem
 * beheert is de indeling het verschil tussen een naslagwerk en een hoop van
 * eenenzeventig woorden: een klantnaam en een norm hebben niets met elkaar te
 * maken en horen niet door elkaar te staan.
 */
export const VOCABULAIRE_GROEPEN = [
    { id: 'onderhoudsstrategie', label: 'Onderhoudsstrategieën' },
    { id: 'methode', label: 'Methoden en analyses' },
    { id: 'systeem', label: 'Systemen' },
    { id: 'norm', label: 'Normen en certificering' },
    { id: 'intern', label: 'Interne termen' },
    { id: 'tooling', label: 'Tools uit gesprekken' },
    { id: 'sector', label: 'Sectoren en objecten' },
    { id: 'klant', label: 'Klanten' },
    { id: 'overig', label: 'Overig' },
];
/**
 * Leest de opgeslagen waarde, die twee vormen kan hebben.
 *
 * Oudere versies bewaarden losse woorden zonder indeling. Die blijven leesbaar
 * en belanden onder "Overig" — een migratie zou hier niets toevoegen, want de
 * indeling is presentatie en de termen zelf zijn de gegevens.
 */
export function leesTermen(ruw) {
    if (!Array.isArray(ruw))
        return [];
    const uit = [];
    const gezien = new Set();
    for (const rij of ruw) {
        const term = typeof rij === 'string' ? rij.trim() : String(rij?.term ?? '').trim();
        if (!term)
            continue;
        const sleutel = term.toLowerCase();
        if (gezien.has(sleutel))
            continue;
        gezien.add(sleutel);
        const ruwGroep = typeof rij === 'string' ? '' : String(rij?.groep ?? '');
        const groep = VOCABULAIRE_GROEPEN.some((g) => g.id === ruwGroep)
            ? ruwGroep
            : 'overig';
        uit.push({ term, groep });
    }
    return uit;
}
/** Wat het transcriptiemodel krijgt: alleen de woorden. */
export const alleenWoorden = (termen) => termen.map((t) => t.term);
